import { TourDefinition } from "@/context/TourContext";

export const TOUR_DEFINITIONS: TourDefinition[] = [
  {
    id: "tour-menu-intro",
    name: "Introducción al Menú de Tours",
    description:
      "Descubre cómo acceder a los tours desde el menú de navegación.",
    category: "overview",
    icon: "🎯",
    estimatedDuration: "1 min",
    hidden: true,
    steps: [
      {
        id: "tour-menu-section",
        target: "tour-menu-section",
        title: "Menú de Tours",
        content:
          'Aquí puedes encontrar todos los tours disponibles. Haz clic en el botón "Tours" para ver las opciones disponibles y tomar cualquier tour cuando lo necesites.',
        placement: "bottom-center",
      },
    ],
  },
  {
    id: "overview",
    name: "Tour general",
    description:
      "Conoce la estructura general de la aplicación y cómo navegar por ella.",
    category: "overview",
    icon: "🏠",
    autoLaunch: true,
    estimatedDuration: "3-4 min",
    steps: [
      {
        id: "drawer-groups",
        target: "tour-drawer",
        title: "Organización del Panel",
        content:
          "Este es tu panel de navegación principal. Está dividido en dos grupos principales: Clientes y empleados.",
        placement: "right-center",
      },
      {
        id: "clientes-group",
        target: "tour-clientes-group",
        title: "Grupo Clientes",
        content:
          'El grupo "Clientes" contiene todas las funciones de gestión de clientes y pacientes. Aquí encontrarás herramientas para manejar contratos, registros de clientes/pacientes y facturación.',
        placement: "right-top",
      },
      {
        id: "empleados-group",
        target: "tour-empleados-group",
        title: "Grupo Empleados",
        content:
          'El grupo "Empleados" contiene todas las funciones de gestión de personal. Aquí encontrarás herramientas para manejar empleados, pagos y programación de turnos.',
        placement: "right-center",
      },
      // {
      //   id: 'otros-group',
      //   target: 'tour-otros-group',
      //   title: 'Grupo Otros',
      //   content: 'El grupo "Otros" contiene herramientas adicionales y funciones especializadas. Aquí encontrarás funciones como conciliación bancaria y otras utilidades.',
      //   placement: 'right-bottom',
      // },
      {
        id: "settings-section",
        target: "tour-settings",
        title: "Configuración",
        content:
          "Accede a configuraciones del sistema, preferencias de usuario, configuración de cuenta y opciones de personalización.",
        placement: "right-bottom",
      },
      // {
      //   id: 'navbar',
      //   target: 'tour-navbar',
      //   title: 'Barra de Navegación',
      //   content: 'La barra de navegación superior muestra el título de tu página actual y proporciona acceso rápido al botón de retroceso y menú de usuario.',
      //   placement: 'bottom-center',
      // },
      {
        id: "tour-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour General. ¿Te gustaría continuar explorando con el Tour de Contratos para aprender sobre la gestión de contratos, plantillas y documentos legales?",
        placement: "center",
        isTransition: true,
        nextTour: "contracts",
      },
    ],
  },
  {
    id: "contracts",
    name: "Áreas de servicio",
    description:
      "Gestionar contratos, ubicaciones y unidades, sus datos principales y plantillas",
    category: "module",
    icon: "📄",
    estimatedDuration: "2-3 min",
    route: "/service-scopes",
    steps: [
      {
        id: "contracts-filters",
        target: "tour-contracts-filters",
        title: "Filtros y Búsqueda",
        content:
          "Usa estos filtros para localizar contratos, ubicaciones y unidades activas dentro de areas de servicio.",
        placement: "bottom-left",
      },
      {
        id: "contracts-overview",
        target: "tour-contracts-overview",
        title: "Listado de contratos, ubicaciones y unidades",
        content:
          "Siempre tendrás ubicaciones que define donde se planean los turnos.  Puedes crear unidades dentro de ellas para tener un planeación más detallada.  En ocasiones también podrás tener contratos asociados según tu actividad.",
        placement: "bottom-center",
      },
      {
        id: "contracts-tabs",
        target: "tour-contracts-tabs",
        title: "Pestañas",
        content:
          "Al seleccionar un contrato, una ubicación o una unidad, podrás ver más información asociada a cada uno.",
        placement: "top-center",
      },
      {
        id: "contracts-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour de Contratos. ¿Te gustaría continuar explorando con el Tour de Clientes y Pacientes para aprender sobre la gestión de información de clientes y pacientes?",
        placement: "center",
        isTransition: true,
        nextTour: "clients-patients",
      },
    ],
  },
  {
    id: "clients-patients",
    name: "Clientes y Pacientes",
    description:
      "Descubre cómo gestionar la información de tus clientes y pacientes.",
    category: "module",
    icon: "👥",
    estimatedDuration: "2-3 min",
    route: "/clients-patients",
    steps: [
      {
        id: "clients-search",
        target: "tour-clients-search",
        title: "Búsqueda de clientes",
        content:
          "Usa la barra de búsqueda para encontrar clientes específicos por nombre o teléfono.",
        placement: "bottom-left",
      },
      {
        id: "clients-list",
        target: "tour-clients-list",
        title: "Lista de clientes",
        content: "Aquí puedes ver todos tus clientes y pacientes organizados.",
        placement: "bottom-center",
      },
      {
        id: "clients-add",
        target: "tour-clients-add",
        title: "Agregar cliente",
        content:
          "Puedes agregar aquí un nuevo cliente o paciente.  Sin embargo, si le envías el formulario a tu cliente en la sección de contrato, no tendrías que hacer nada.",
        placement: "bottom-right",
        action: "click",
      },
      {
        id: "clients-tabs",
        target: "tour-clients-patients-tabs",
        title: "Pestañas de información",
        content:
          "Estas pestañas te permiten ver y editar diferentes aspectos del cliente/paciente seleccionado.",
        placement: "top-center",
      },
      {
        id: "clients-patients-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour de Clientes y Pacientes. ¿Te gustaría continuar explorando con el Tour de Facturas para aprender sobre la creación y gestión de facturas?",
        placement: "center",
        isTransition: true,
        nextTour: "invoices",
      },
    ],
  },
  {
    id: "invoices",
    name: "Facturación",
    description: "Gestiona las facturas de tus clientes.",
    category: "module",
    icon: "💰",
    estimatedDuration: "3-4 min",
    route: "/invoices",
    steps: [
      {
        id: "invoices-filters",
        target: "tour-invoices-filters",
        title: "Filtros de Facturas",
        content: "Usa estos filtros para encontrar facturas específicas.",
        placement: "bottom-center",
      },
      {
        id: "invoices-overview",
        target: "tour-invoices-overview",
        title: "Lista de facturas",
        content:
          "Aquí puedes ver el listado de facturas de acuerdo a los filtros aplicados.",
        placement: "bottom-center",
      },
      {
        id: "invoices-details",
        target: "tour-invoices-details",
        title: "Detalles de factura",
        content: "Selecciona una factura el detalle de la misma por día.",
        placement: "top-center",
      },
      {
        id: "invoices-actions",
        target: "tour-invoices-convert-button",
        title: "Emitir factura",
        content:
          "El sistema automáticamente genera facturas temporales.  Este botón te permite convertirlas a facturas en firme con un número consecutivo.  Solo tienes que seleccionar las facturas que quieres generar. ",
        placement: "top-right",
      },
      {
        id: "invoices-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour de Facturas. ¿Te gustaría continuar explorando con el Tour de Empleados para aprender sobre la gestión de personal y perfiles profesionales?",
        placement: "center",
        isTransition: true,
        nextTour: "employees",
      },
    ],
  },
  {
    id: "employees",
    name: "Empleados",
    description: "Gestiona la información de tus candidatos y empleados.",
    category: "module",
    icon: "👨‍💼",
    estimatedDuration: "4-5 min",
    route: "/people",
    steps: [
      {
        id: "employees-overview",
        target: "tour-employees-overview",
        title: "Lista de empleados",
        content:
          "Aquí puedes ver los empleados y prospectos a los cuales tienes acceso.",
        placement: "bottom-center",
      },
      {
        id: "employees-filter-button",
        target: "tour-employees-filter-button",
        title: "Botón de filtros",
        content:
          "Además de filtrar por nombre o teléfono, este botón de filtros te da acceso a filtros avanzados a través de un panel lateral.",
        placement: "bottom-right",
        action: "click",
      },
      {
        id: "employees-filter-sidebar",
        target: "tour-employees-filter-sidebar",
        title: "Panel de filtros",
        content:
          "Este es el panel lateral de filtros. Aquí puedes aplicar múltiples criterios para encontrar prospectos ideales.",
        placement: "left-center",
      },

      {
        id: "employees-tags",
        target: "tour-employees-tags",
        secondaryTarget: "tour-employees-tags-menu",
        title: "Gestión de etiquetas",
        content:
          "Puedes asignar y gestionar etiquetas para agrupar candidatos o empleados.  Por ejemplo podrías agrupar candidatos que podrían servir para un cliente en particular.",
        details:
          "Una vez que le asignas una etiqueta a una persona, puedes posteriormente utilizar un filtro de etiqueta para mostrarlos en el listado.",
        placement: "left-center",
        tooltipTarget: "secondary",
        action: "click",
      },
      {
        id: "employees-add-candidate",
        target: "tour-employees-add-candidate",
        secondaryTarget: "tour-employees-add-candidate-menu",
        title: "Agregar candidato",
        content:
          "La manera ideal de agregar candidatos es enviándoles el formulario para que ellos lo completen.  Asi reduces el trabajo que tienes que realizar, evitas errores y aumentas la calidad de información que obtienes",
        details:
          "Tienes varias opciones para compartir el enlace.  Puedes colocar este enlace en tu sitio web por ejemplo y automáticamente verás nuevos candidatos.  También puede agregar manualmente un candidato, pero no es recomendado.",
        placement: "left-center",
        tooltipTarget: "secondary",
        action: "click",
      },
      {
        id: "employees-tabs",
        target: "tour-employees-tabs",
        title: "Pestañas de empleado",
        content:
          "Una vez seleccionado una persona, puedes ver sus detalles completos en estas pestañas.",
        placement: "top-center",
      },
      {
        id: "employees-tab-general",
        target: "tour-employees-tab-general",
        secondaryTarget: "tour-employees-tab-general-content",
        title: "Pestaña general",
        content:
          "Información básica del empleado: datos personales, contacto y detalles del puesto.  Si la persona tiene whatsapp, puedes enviar mensajes automatizados que configuras en ajustes.",
        details:
          "Por ejemplo, tal vez quieras configurar un mensaje para invitar a entrevista y con solo un botón se prepara y no tienes que escribirlo para cada candidato.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-education",
        target: "tour-employees-tab-education",
        secondaryTarget: "tour-employees-tab-education-content",
        title: "Pestaña idiomas",
        content:
          "Registra los idiomas que habla la persona y su nivel en cada uno.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-interview",
        target: "tour-employees-tab-interview",
        secondaryTarget: "tour-employees-tab-interview-content",
        title: "Pestaña entrevista",
        content:
          "Puedes definir una lista de preguntas de entrevista que sirvan de guía.  Al momento de la entrevista, le puedes dar un puntaje a cada respuesta y obtener una calificación del candidato.",
        details:
          "Esta guía de preguntas de entrevista la puedes configurar en los ajustes.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-availability",
        target: "tour-employees-tab-availability",
        secondaryTarget: "tour-employees-tab-availability-content",
        title: "Pestaña disponibilidad",
        content: "Disponibilidad de la persona para trabajar.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-log",
        target: "tour-employees-tab-log",
        secondaryTarget: "tour-employees-tab-log-content",
        title: "Pestaña bitácora",
        content:
          "Registro de actividades, cambios y eventos relacionados con el candidato o empleado.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-send",
        target: "tour-employees-tab-send",
        secondaryTarget: "tour-employees-tab-send-content",
        title: "Pestaña enviar info",
        content:
          "Comparte la información detallada del contrato.  El candidato recibirá un página en donde podrá ver la información y aceptarla o rechazarla.",
        details:
          "Puedes configurar el mensaje y el tiempo de expiración de la información.  También puede evitar compartir datos personales si aún quieres mantener la confidencialidad.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-financials",
        target: "tour-employees-tab-financials",
        secondaryTarget: "tour-employees-tab-financials-content",
        title: "Pestaña finanzas",
        content:
          "Información financiera del empleado, incluyendo cuentas bancarias y expectativa salarial.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-files",
        target: "tour-employees-tab-files",
        secondaryTarget: "tour-employees-tab-files-content",
        title: "Pestaña archivos",
        content:
          "Revisa los documentos que el candidato haya subido como hoja de vida, títulos, identificación, etc.",
        details:
          "De esta manera tienes toda la información organizada, centralizada y fácil de consultar. Si no hay documentos, el mismo candidato debe subirlos a través del formulario.",
        placement: "top-left",
        action: "click",
      },
      {
        id: "employees-tab-other",
        target: "tour-employees-tab-other",
        secondaryTarget: "tour-employees-tab-other-content",
        title: "Pestaña otros",
        content:
          "Administra las etiquetas y categorías asignadas a la persona.  También puedes configurar consultar o modificar otros datos",
        details:
          "Si no quieres volver a contratar a esta persona, la puedes marcar como no contratable y desaparecerá del listado de candidatos.  Si no está disponible, también desaparecerá pero sabrás que se puede contratar.  ",
        placement: "top-center",
        action: "click",
      },
      {
        id: "employees-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour de Empleados. ¿Te gustaría continuar explorando con el Tour de Pagos para aprender sobre el registro y gestión de pagos?",
        placement: "center",
        isTransition: true,
        nextTour: "payments",
      },
    ],
  },
  {
    id: "payments",
    name: "Pagos",
    description: "Gestiona los pagos a tus empleados.",
    category: "module",
    icon: "💳",
    estimatedDuration: "2-3 min",
    route: "/payments",
    steps: [
      {
        id: "payments-filters",
        target: "tour-payments-filters",
        title: "Filtros de Pagos",
        content:
          "Usa estos filtros para encontrar pagos específicos por estado y ciclo de pago.",
        placement: "bottom-center",
      },
      // {
      //   id: 'payments-summary',
      //   target: 'tour-payments-summary',
      //   title: 'Resumen de pagos',
      //   content: 'Aquí puedes ver el resumen de todos los pagos: total de pagos, total pagado, total pendiente y número de empleados.',
      //   placement: 'bottom-center',
      // },
      {
        id: "payments-overview",
        target: "tour-payments-overview",
        title: "Lista de pagos",
        content: "Aquí puedes ver todos los pagos registrados y pendientes.",
        details:
          "Ingresa el código de la transacción del banco en la columna Ref. bancaria para registrar el pago como realizado.  La fecha se actualizará automáticamente a la fecha de hoy o puedes cambiarla manualmente.",
        placement: "bottom-center",
      },
      {
        id: "payments-transition",
        target: "tour-transition",
        title: "¡Excelente trabajo!",
        content:
          "Has completado el Tour de Pagos. ¿Te gustaría continuar explorando con el Tour de Programación para aprender sobre la programación de citas y gestión de horarios?",
        placement: "center",
        isTransition: true,
        nextTour: "scheduling",
      },
    ],
  },
  {
    id: "scheduling",
    name: "Programación",
    description: "Gestiona los horarios de tus empleados.",
    category: "module",
    icon: "📅",
    estimatedDuration: "3-4 min",
    route: "/scheduling",
    steps: [
      {
        id: "scheduling-controls-left",
        target: "tour-scheduling-controls-left",
        title: "Selectores",
        content:
          "Selecciona el ciclo y contrato que quieres gestionar.  Verás un icono en el último ciclo que ha sido cerrado.",
        details:
          "Los ciclos se deben ir cerrando para no permitir que se realicen cambios.  Esto es importante para que los pagos que se realicen, coincidan con los turnos registrados en ese ciclo.",
        placement: "bottom-left",
      },

      {
        id: "scheduling-overview-dates-contracts",
        target: "tour-scheduling-overview-dates-contracts",
        title: "Columnas de fecha y contrato",
        content:
          "Estas columnas muestran las fechas del ciclo seleccionado, así como las horas que demanda el contrato selecccionado.  Esta información viene de la plantilla de horarios definida en el contrato.",
        details:
          "No es necesario crear plantillas pero ahorran mucho tiempo y evitan errores.  Puedes ingresar horarios manualmente.  También puedes modificar el horario de un día en particular tenga una variación.  Cualquier variación con respecto a la plantilla se marca con otro color de fondo.",
        placement: "right-center",
      },
      {
        id: "scheduling-overview-employees",
        target: "tour-scheduling-overview-employees",
        title: "Columna de empleados",
        content:
          "Aquí se muestran los empleados asignados a cada turno. Puedes hacer clic en un empleado para ver sus detalles o cambiar la asignación.",
        details:
          "Si posiciones el mouse sobre un turnos, podrás acceder a funciones rápidas que te permitirán copia, cortar, borrar y pegar turnos.",
        placement: "right-center",
      },
      {
        id: "scheduling-overview-variations",
        target: "tour-scheduling-overview-variations",
        title: "Variaciones en horarios",
        content:
          "Si el horario demandado no coincide con los turnos, se presentará una alerta.",
        details:
          "Esta fila muestra un ejemplo de variación en los horarios programados. El 1 de octubre el turno de Carlos Arias se modificó con respecto a la plantilla y tiene una hora menos que el horario del contrato.",
        placement: "bottom-center",
      },
      {
        id: "scheduling-overview-shift-details",
        target: "tour-scheduling-overview-shift-details",
        title: "Detalles de turnos",
        content:
          "Esta área muestra los detalles específicos de cada turno, incluyendo horarios, tarifas y ajustes.  También considera los feriados que se calculan automáticamente.",
        placement: "left-center",
      },
      {
        id: "scheduling-view-by-selector",
        target: "tour-scheduling-view-by-selector",
        title: "Selector de vista",
        content:
          "Este selector te permite cambiar entre vista por contrato o candidato. La vista por contrato muestra todos los empleados de un contrato específico, mientras que la vista por candidato muestra todos los contratos de un empleado específico.",
        placement: "bottom-right",
      },
      {
        id: "scheduling-time-money-selector",
        target: "tour-scheduling-time-money-selector",
        title: "Selector de tiempo/dinero",
        content:
          "Este selector te permite alternar entre vista de tiempo (mostrando horarios) y vista de dinero (mostrando montos y tarifas). Útil para efectos de revisión de pagos.",
        placement: "bottom-right",
      },
    ],
  },
  // {
  //   id: 'bank-reconciliation',
  //   name: 'Conciliación bancaria',
  //   description: 'Aprende a conciliar estados bancarios con tus registros financieros.',
  //   category: 'module',
  //   icon: '🏦',
  //   estimatedDuration: '3-4 min',
  //   route: '/bank',
  //   steps: [
  //     {
  //       id: 'bank-tabs',
  //       target: 'tour-bank-reconciliation-tabs',
  //       title: 'Pestañas de conciliación',
  //       content: 'Aquí puedes ver las diferentes vistas de conciliación bancaria: Pendientes, Conectadas y Conciliadas.',
  //       placement: 'bottom-center',
  //     },
  //     {
  //       id: 'bank-pending',
  //       target: 'tour-bank-reconciliation-pending',
  //       title: 'Transacciones pendientes',
  //       content: 'Aquí puedes ver las transacciones bancarias que aún no han sido conectadas con tus registros.',
  //       placement: 'bottom-center',
  //     },
  //     {
  //       id: 'bank-connected',
  //       target: 'tour-bank-reconciliation-connected',
  //       title: 'Transacciones conectadas',
  //       content: 'Aquí puedes ver las transacciones bancarias que han sido conectadas con tus registros pero aún no conciliadas.',
  //       placement: 'bottom-center',
  //     },
  //     {
  //       id: 'bank-reconciled',
  //       target: 'tour-bank-reconciliation-reconciled',
  //       title: 'Transacciones conciliadas',
  //       content: 'Aquí puedes ver las transacciones bancarias que han sido completamente conciliadas con tus registros.',
  //       placement: 'bottom-center',
  //     },
  //     {
  //       id: 'bank-reconciliation-transition',
  //       target: 'tour-transition',
  //       title: '¡Excelente trabajo!',
  //       content: 'Has completado todos los tours disponibles. ¡Ahora conoces todas las funcionalidades principales de la aplicación! Puedes volver a tomar cualquier tour cuando lo necesites desde el menú de navegación.',
  //       placement: 'center',
  //       isTransition: true,
  //       nextTour: 'overview',
  //     },
  //   ],
  // },
];

export const getTourById = (tourId: string): TourDefinition | undefined => {
  return TOUR_DEFINITIONS.find((tour) => tour.id === tourId);
};

export const getToursByCategory = (
  category: "overview" | "module",
): TourDefinition[] => {
  return TOUR_DEFINITIONS.filter((tour) => tour.category === category);
};

export const getAutoLaunchTour = (): TourDefinition | undefined => {
  return TOUR_DEFINITIONS.find((tour) => tour.autoLaunch);
};

export const getTourInfo = (
  tourId: string,
): { name: string; icon: string; category: string } | null => {
  const tour = getTourById(tourId);
  if (!tour) return null;

  return {
    name: tour.name,
    icon: tour.icon,
    category: tour.category,
  };
};
